import Event from '../../../../../utils/event';
import {USER_EVENTS, SYSTEM_EVENTS} from '../../../../../events/events';
import BaseComponent from '../../../../../base/base_component';
import {NAVIGATION_VIEWS} from '../../../../external_links/external_links_consts';


let view = require('./view/new_jersey_responsible_gaming_icons.html');

export default class NewJerseyResponsibleGamingIconsController extends BaseComponent {
    static CLASS = 'NewJerseyResponsibleGamingIconsController';

    init(params) {
        super.init(params);
    }

    start() {
        let bakedHTML = this.bake(view);
        this.setHTML(bakedHTML);
        this._subscribe();
    }


    _subscribe() {
        // open cashier on panic button click
        this.onChildElementEvent('.cgp-nj-resp-game-icon', USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('nj_resp_game_icon');
            this.serviceFactory.openLinkService().openResponsibleGamblingLink();
        });

        // open cashier on panic button click
        this.onChildElementEvent('.nj-name-and-flag', USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('nj_flag_icon');
            this.serviceFactory.openLinkService().openLink(
                {
                    sourceLink: this.serviceFactory.skinService().getSafeToPlayURL(),
                    view: NAVIGATION_VIEWS.WINDOW
                }
            );
        });
    }


    _sendAnalytics(label) {
        const analyticObject = {
            category: 'Navigation',
            action: 'Header',
            label: 'Icon_' + label
        };
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticObject);
    }
}